<template>
  <div class="container">

    <heading-one class="-margin-md">ご本人さま確認書類のご提出</heading-one>

    <errors-alert :errors="errors"></errors-alert>

    <slot name="wizard"></slot>

    <section>
      <heading-three class="_mt-sm-40 _mt-md-60">アップロード前にご確認ください</heading-three>
      <p>以下の場合は、再提出が必要となりますのでご注意ください。</p>
      <list-group class="-normal _mb-sm-30 _mb-md-50">
        <list-item class="-normal">画像が極端に小さい、切れている、ぼやけている</list-item>
        <list-item class="-normal">本籍地、個人番号（マイナンバー）、健康保険証の保険者番号・記号・番号（介護保険の被保険者証および自衛官診療証を除く）、臓器提供意思などが記載されており紙などで隠されていない状態</list-item>
      </list-group>

      <heading-two>{{displayIdentityLabel}}</heading-two>
      <div class="row _mb-sm-40 _mb-md-60">
        <div v-if="!!userData.file_data1" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
          <heading-three>{{displayFile1Label}}</heading-three>
          <confirm-image :file-name="userData.file_name1" :file-data="userData.file_data1"></confirm-image>
        </div>
        <div v-if="(identity !== '05') && !!userData.file_data2" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
          <heading-three>{{displayFile2Label}}</heading-three>
          <confirm-image :file-name="userData.file_name2" :file-data="userData.file_data2"></confirm-image>
        </div>
      </div>
      <div v-if="(identity === '04' || identity === '05') && (subIdentity === '01' || subIdentity === '02')">
        <heading-two>{{displaySubIdentityLabel}}</heading-two>
        <div class="row _mb-sm-40 _mb-md-60">
          <div v-if="!!userData.file_data3" class="col-12 col-md-6">
            <heading-three>{{displayFile3Label}}</heading-three>
            <confirm-image :file-name="userData.file_name3" :file-data="userData.file_data3"></confirm-image>
          </div>
        </div>
      </div>
      <div v-if="(nationality === '02') && (proofNationality === '03' || proofNationality === '04')">
        <heading-two>{{displayProofNationalityLabel}}</heading-two>
        <div class="row _mb-sm-40 _mb-md-60">
          <div v-if="!!userData.file_data4" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>{{displayFile4Label}}</heading-three>
            <confirm-image :file-name="userData.file_name4" :file-data="userData.file_data4"></confirm-image>
          </div>
          <div v-if="!!userData.file_data5" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <heading-three>{{displayFile5Label}}</heading-three>
            <confirm-image :file-name="userData.file_name5" :file-data="userData.file_data5"></confirm-image>
          </div>
        </div>
      </div>

      <form v-if="topPageId === 'en007'" @submit.prevent="submitIdentifyFile" onmousedown="dlpoloan_honninkakuninshoruiteishutsuClickCv()">
        <btngroup-single class="_mb-sm-40">
          <btn-main class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </btn-main>
        </btngroup-single>
      </form>

      <form v-if="topPageId === 'en026'" @submit.prevent="submitIdentifyFile" onmousedown="dlpoloan_sai_honninkakuninshoruiteishutsuClickCv()">
        <btngroup-single class="_mb-sm-40">
          <btn-main class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </btn-main>
        </btngroup-single>
      </form>

      <form v-if="(topPageId !== 'en007' && topPageId !== 'en026')" @submit.prevent="submitIdentifyFile">
        <btngroup-single class="_mb-sm-40">
          <btn-main class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </btn-main>
        </btngroup-single>
      </form>

      <btngroup-single class="-margin-lg">
        <btn-back class="-back -md" @click.prevent="goBack">
          修正する
        </btn-back>
      </btngroup-single>

    </section>

  </div>
</template>

<script>
import { initCredentials } from '../../utils/Auth'
import { getUserDataLambdaInvoke, submitEditIdentifyFileLambdaInvoke } from '../../utils/LambdaHelper'
import fileUpload from '../../components/mixin/FileUpload'

import HeadingOne from '../../components/heading/HeadingOne'
import WizardGroup from '../../components/wizard/WizardGroup'
import MainWizard from '../../components/wizard/MainWizard'
import SubWizard from '../../components/wizard/SubWizard'
import HeadingTwo from '../../components/heading/HeadingTwo'
import HeadingThree from '../../components/heading/HeadingThree'
import ConfirmImage from '../../components/upload/ConfirmImage'
import ListGroup from '../../components/list/ListGroup'
import ListItem from '../../components/list/ListItem'
import BtngroupSingle from '../../components/button/BtngroupSingle'
import BtnMain from '../../components/button/BtnMain'
import BtnBack from '../../components/button/BtnBack'
import ErrorsAlert from '../../components/alert/ErrorsAlert'

export default {
  name: 'identify-confirm',
  mixins: [fileUpload],
  components: {
    ErrorsAlert,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    ConfirmImage,
    HeadingThree,
    HeadingTwo,
    SubWizard,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  props: {
    topPageId: '',
    previousPageId: '',
    nextPageId: ''
  },
  data () {
    return {
      errors: null,
      identity: this.$route.query.identity,
      subIdentity: this.$route.query.subIdentity,
      nationality: this.$route.query.nationality,
      proofNationality: this.$route.query.proofNationality,
      isDisabled: false,
      files: true,
      userData: {
        processing_type: '1',
        file_name1: '',
        file_data1: '',
        file_name2: '',
        file_data2: '',
        file_name3: '',
        file_data3: '',
        file_name4: '',
        file_data4: '',
        file_name5: '',
        file_data5: '',
        file_name6: '',
        file_data6: ''
      }
    }
  },
  methods: {
    submitIdentifyFile (event) {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.checkQueryParam()
        initCredentials().then(res => {
          submitEditIdentifyFileLambdaInvoke().then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              this.setPersonalConfirmImageAtCookie()
              this.$router.push({name: this.nextPageId})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    checkQueryParam () {
      try {
        if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering) {
          // ビルド時の静的ファイル生成時はチェックしない
          return
        }
        if (['01', '02', '03', '04', '05'].indexOf(this.$route.query.identity) === -1) {
          this.$router.push({name: this.topPageId})
        }
        if (['04', '05'].indexOf(this.$route.query.subIdentity) !== -1) {
          if (['01', '02'].indexOf(this.$route.query.subIdentity) === -1) {
            this.$router.push({name: this.topPageId})
          }
        }
        if (['01', '02'].indexOf(this.$route.query.nationality) === -1) {
          this.$router.push({name: this.topPageId})
        }
        if (['02'].indexOf(this.$route.query.nationality) !== -1) {
          if (['03', '04'].indexOf(this.$route.query.proofNationality) === -1) {
            this.$router.push({name: this.topPageId})
          }
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    goBack: function () {
      try {
        let queryParam = {
          identity: this.identity || '00',
          subIdentity: this.subIdentity || '00',
          nationality: this.nationality || '02',
          proofNationality: this.proofNationality || '00'
        }
        this.$router.push({name: this.previousPageId, query: queryParam})
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  },
  created () {
    this.checkQueryParam()
  },
  mounted () {
    try {
      getUserDataLambdaInvoke(this.files).then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fileupload/IdentifyConfirm.vue